import React, {useCallback, useState} from 'react';
import {Box, Fade, Modal, Typography} from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import CloseIcon from "@mui/icons-material/Close";
import {global, input} from "../translate";
import Api from "../Api";
import {toast} from "react-toastify";
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: window.innerWidth > 400 ? 400 : window.innerWidth,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    height: 'auto',
    overflow: 'hidden'
};
function UrsMessageBlock({open,setOpen,setList, setWho,setMessage,message,who,list}) {
    const [loader, setLoader] = useState(false)
    const handleSubmit = useCallback(async ( ) => {
        try {
            setLoader(true)
            if(who === 'array'){
                const {data} = await Api.sendUrsMessage(message, list)
                setList(data.members)
                toast.success("Հաղորդագրությունը ուղարկվել է բոլորին")
            }else{
                let newList = list.filter(l => l.id === who)
                const {data} = await Api.sendUrsMessage(message, newList)
                setList(data.members)
                toast.success(`Հաղորդագրությունը ուղարկվել է ${newList[0].fio} - ին`)

            }
            setLoader(false)
            setOpen('')
            setWho('')
        }catch (e) {

        }
    },[message,who,list])
    return (
        <>

            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={!!open}
                onClose={() => {
                    setOpen('')
                }}
                closeAfterTransition
                slots={{backdrop: Backdrop}}
                slotProps={{
                    backdrop: {
                        timeout: 500,
                    },
                }}
            >
                <Fade in={!!open}>
                    <Box sx={style}>
                        <div className="d-flex flex-row justify-content-between">
                            <Typography id="transition-modal-title" variant="h6" component="h2">
                                Ուղարկվող հաղորդագրություն
                            </Typography>
                            <span style={{cursor: 'pointer'}} onClick={() => {
                                setOpen('')
                            }}>
                                <CloseIcon/>

                        </span>
                        </div>
                        <form onSubmit={handleSubmit} id="transition-modal-description sip_content" className="test_mode">
                            <label className="count" style={{width: '86%'}}>
                                <textarea style={{height:150, padding:3}} value={message} onChange={(ev) => setMessage(ev.target.value)}/>
                            </label>
                            <div className="d-flex justify-content-center">
                                <span style={{marginTop:20,padding: '6px 17px'}} className="addBtnBig" onClick={handleSubmit}>
                                    {loader?'Loading...':global.edit[+localStorage.getItem('atsLang')  || 1]}
                                </span>
                            </div>
                        </form>
                    </Box>
                </Fade>
            </Modal>
        </>

    );
}

export default UrsMessageBlock;